//modificar fondo final de euros del centro para esta semana
//

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { modifyVariacionEuros } from '../../actions/cierre_semanal_actions';

import TextField from '@material-ui/core/TextField';
import { Paper, Typography, } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';

import FloatNumberFormatInput from '../../components/float_number_input_formatter';

const styles = theme => ({
    root: {
        margin: '8px 0',
        width: '245'
    },
    paperConcepto: {
        padding: 0,
        margin: 8,
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
    },
    titleIngresos: {
        fontSize: '15px',
        fontWeight: '500',
        color: 'white',
        backgroundColor: grey[600],
        padding: '4px 2px 4px 12px',
    },
    paperItem: {
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 25px',
        boxShadow: 'none',
    },
    containeritems: {
        width: '100%',
        margin: '8px auto',
    },
    label: {
        maxWidth: '50%',
        fontSize: 13
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 11,
        height: 19
    },
    input: {
        width: 75,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important',
        },
    },
    editableInput: {
        width: 75,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: '#8dbb35 !important',
        },
    },
});

class CierreSemanalEuros extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fondoInicial: this.props.datosCierreSemanal.fondoEurosIni,
            fondoFinal: this.props.datosCierreSemanal.fondoEurosEnd,
            variacion: this.props.datosCierreSemanal.fondoEurosEnd - this.props.datosCierreSemanal.fondoEurosIni,
            lastCentroDia: this.props.centroDiaSelected.centro.id + '_' + this.props.centroDiaSelected.dia
        };
    };


    static getDerivedStateFromProps(nextProps, prevState) {

        if (prevState.lastCentroDia !== nextProps.centroDiaSelected.centro.id + '_' + nextProps.centroDiaSelected.dia) {
            return {
                fondoInicial: nextProps.datosCierreSemanal.fondoEurosIni,
                fondoFinal: nextProps.datosCierreSemanal.fondoEurosEnd,
                variacion: nextProps.datosCierreSemanal.fondoEurosEnd - nextProps.datosCierreSemanal.fondoEurosIni,
                lastCentroDia: nextProps.centroDiaSelected.centro.id + '_' + nextProps.centroDiaSelected.dia
            };
        }
        else {
            return null;
        };

    };

    renderItem = (label, value) => {
        const { classes } = this.props;
        return [
            <form key={label + '-label'}>
                <Paper className={classes.paperItem} >

                    <Typography variant="subtitle2" className={classes.label}>
                        {label}
                    </Typography>

                    <TextField
                        id={label}
                        key={label + '-value'}
                        value={value}
                        className={classes.input}
                        InputProps={{
                            classes: { input: classes.inputImporte },
                            inputComponent: FloatNumberFormatInput
                        }}
                        disabled
                        variant="outlined"

                    />
                </Paper>
            </form>
        ]
    };

    handleVariacionChange = event => {
        this.setState({
            ...this.state,
            variacion: event.target.value,
            fondoFinal: parseFloat(this.state.fondoInicial) + parseFloat(event.target.value)
        });
    };

    onValueChange = value => {
        this.props.modifyVariacionEuros(this.state.fondoFinal);
    };

    renderVariacion = () => {
        const { classes } = this.props;
        return [
            <form key={'variacion-label'}>
                <Paper className={classes.paperItem} >

                    <Typography variant="subtitle2" className={classes.label}>
                        Variación Fondo
                    </Typography>

                    <TextField
                        id={"variacion"}
                        key={'variacion-value'}
                        value={this.state.variacion}
                        className={!this.props.isSemanaCerrada ? classes.editableInput : classes.input}
                        InputProps={{
                            classes: { input: classes.inputImporte },
                            inputComponent: FloatNumberFormatInput
                        }}
                        variant="outlined"
                        onChange={(event) => this.handleVariacionChange(event)}
                        onBlur={(event) => this.onValueChange(event.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') { e.preventDefault(); this.onValueChange(e.target.value) };
                        }}
                    disabled={this.props.isSemanaCerrada}
                    />
                </Paper>
            </form>
        ]
    };

    render() {
        const { classes } = this.props;

        if (!this.props.datosCierreSemanal.cajaIDgeneral === undefined) {
            return (<div></div>);
        };

        return (
            <div className={classes.root}>
                <Paper className={classes.paperConcepto} elevation={0}>
                    <Typography variant="subtitle1" className={classes.titleIngresos}>Euros</Typography>
                    <div className={classes.containeritems}>
                        {this.renderItem("Fondo inicial", this.props.datosCierreSemanal.fondoEurosIni)}
                        {this.renderVariacion()}
                        {this.renderItem("Fondo final", this.state.fondoFinal)}
                    </div>
                </Paper>
            </div>
        );
    };
};


CierreSemanalEuros.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    isSemanaCerrada: PropTypes.bool.isRequired,
    datosCierreSemanal: PropTypes.object.isRequired,
    //dispatch
    modifyVariacionEuros: PropTypes.func.isRequired

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        isSemanaCerrada: state.datosCierreSemanal.semanaCerrada,
        datosCierreSemanal: state.datosCierreSemanal.datos,
        user: state.oidc.user
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyVariacionEuros
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalEuros));